import { baseApi } from '@shared/api'
import { orderDetailsApi } from './orderDetails.api'
import { orderStatusListType } from 'store/types/salaryCard'

export interface SalaryCardListRequest {
  startDate: string
  endDate: string
  searchText: string
  status: string
  page: number
  pageCount: number
}

export interface SalaryCardStatusListRequest {
  searchText: string
  startDate: string
  endDate: string
}

export interface SalaryCardStatusList {
  status: string
  count: number
}

export interface SalaryCardShortList {
  totalCount: number
  orderList: SalaryCardShortDetail[]
}

export interface SalaryCardShortDetail {
  createdDate: string
  orderNo: string
  cardType: 'VISA' | 'MASTERCARD'
  cardCurrency: string
  orderType: string
  orderDeliveryType: string
  totalCount: number
  rejectedCount: number
  status: string
  transactionId: string
}

export const salaryCardListApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSalaryCardList: builder.query<
      SalaryCardShortList,
      SalaryCardListRequest
    >({
      query: (data) => {
        return {
          url: '/ib/order/card/salary/short-list',
          method: 'POST',
          data,
        }
      },
      serializeQueryArgs: ({ queryArgs }) => 'fetchSalaryCardList',
      providesTags: (result) => {
        return result
          ? [
              ...result.orderList.map(({ orderNo }) => ({
                type: 'SalaryCardList' as const,
                id: orderNo,
              })),
              { type: 'SalaryCardList', id: 'List' },
            ]
          : [{ type: 'SalaryCardList', id: 'List' }]
      },
    }),
    fetchCreateSalaryCard: builder.mutation<any, any>({
      query: (data) => ({
        url: '/ib/order/card/salary/create',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['SalaryCardStatusList', 'SalaryCardList'],
    }),
    fetchUpdateSalaryCardOrder: builder.mutation<any, any>({
      query: (data) => ({
        url: '/ib/order/card/salary/update',
        method: 'POST',
        data,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(
            salaryCardListApi.util.invalidateTags(['SalaryCardStatusList'])
          )
          // dispatch(
          //   orderDetailsApi.endpoints.fetchOrderDetails.initiate(
          //     { orderNo: args.orderNo },
          //     { fixedCacheKey: 'fetchOrderDetails', track: false }
          //   )
          // )
        } catch (error) {}
      },
    }),
    fetchDeleteSalaryCardOrder: builder.mutation<any, any>({
      query: (data) => ({
        url: '/ib/order/card/salary/delete',
        method: 'POST',
        data,
        skipGlobalError: true,
      }),
      invalidatesTags: ['SalaryCardStatusList'],
      // async onQueryStarted(_, { dispatch, queryFulfilled }) {
      //   try {
      //     await queryFulfilled
      //     // dispatch(salaryCardListApi.util.invalidateTags(['SalaryCardList']))
      //     dispatch(
      //       salaryCardListApi.util.invalidateTags(['SalaryCardStatusList'])
      //     )
      //   } catch (error) {
      //     dispatch(setGlobalErrorAction(error.error.data ?? ''))
      //   }
      // },
    }),
    fetchSalaryCardStatusList: builder.query<
      orderStatusListType[],
      SalaryCardStatusListRequest
    >({
      query: (data) => ({
        url: '/ib/order/card/salary/statuses',
        method: 'POST',
        data,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled

          if(data.length === 0) {
            dispatch(
              salaryCardListApi.util.updateQueryData('fetchSalaryCardList', 'fetchSalaryCardList', (draftPosts) => {
                draftPosts.orderList.splice(0, draftPosts.orderList.length)
              })
            )
          }
        } catch (error) {}
      },
      providesTags: ['SalaryCardStatusList'],
    }),
    fetchUpdateOrderStatus: builder.mutation<any, any>({
      query: (data) => ({
        url: '/ib/order/card/salary/update/status',
        method: 'POST',
        data,
      }),
      // invalidatesTags: ['SalaryCardStatusList'],
      // async onQueryStarted(queryArgument, { dispatch, queryFulfilled }) {
      //   try {
      //     await queryFulfilled
      //     dispatch(
      //       orderDetailsApi.endpoints.fetchOrderDetails.initiate(
      //         { orderNo: queryArgument.orderNo },
      //         { fixedCacheKey: 'fetchOrderDetails' }
      //       )
      //     )
      //   } catch (error) {
      //     // Hata yönetimi
      //   }
      // },
    }),
  }),
})

export const {
  useFetchSalaryCardListQuery,
  useLazyFetchSalaryCardListQuery,
  useLazyFetchSalaryCardStatusListQuery,
  useFetchUpdateSalaryCardOrderMutation,
  useFetchDeleteSalaryCardOrderMutation,
  useFetchUpdateOrderStatusMutation,
  useFetchCreateSalaryCardMutation,
} = salaryCardListApi
